import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { toast } from 'react-toastify';
import { Button, Popup, Grid, Input, Dimmer, Loader } from 'semantic-ui-react';
import { updateAd, updateStatusAd } from '../../../fbApi/Ad';
import {
  insertAdNote,
  approveQC,
  clearAdQC,
  updateAdHold
} from '../../../services/AdServiceManager';
import getFullNameOrUserName from '../../../utils/user';
import * as AppActions from '../../../actions';

class AdPreviewMultiQc extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      qcNote: '',
      isMultiQcPopupOpen: false,
      newStateAds: [],
      loading: false
    };
  }

  toggleMultiQcPopup = () => {
    const { isMultiQcPopupOpen } = this.state;
    this.setState({ isMultiQcPopupOpen: !isMultiQcPopupOpen });
  };

  toggleMultiQcMode = () => {
    const {
      actions,
      resetReduxSelectedAds,
      showCheckboxesMultiQc,
      selectAllAdsInRedux
    } = this.props;
    this.setState({ isMultiQcPopupOpen: false }, () => {
      if (!showCheckboxesMultiQc && resetReduxSelectedAds)
        resetReduxSelectedAds();
      if (showCheckboxesMultiQc && selectAllAdsInRedux) selectAllAdsInRedux();
      actions.displayMultiQcCheckbox();
    });
  };

  findMatchingAd = (adId) => {
    const { selectedAds } = this.props;
    const campaignKeys = Object.keys(selectedAds);
    let foundAd = {};
    campaignKeys.forEach((key) => {
      foundAd = selectedAds[key].find((ad) => {
        return ad.id === adId;
      });
      if (foundAd) {
        return foundAd;
      }
      return {};
    });

    return foundAd || {};
  };

  findMatchingAdCampaign = (adId) => {
    const { selectedAds } = this.props;
    const campaignKeys = Object.keys(selectedAds);
    let foundKey = '';
    campaignKeys.forEach((key) => {
      const index = selectedAds[key].findIndex((ad) => ad.id === adId);
      if (index !== -1) foundKey = key;
    });
    return foundKey;
  };

  mapQCServiceObject = (result, adNotes) => {
    const { returnQC, name } = result;
    let qcServiceObj = {};
    let newStateAd = {};
    if (returnQC) {
      qcServiceObj = {
        adId: returnQC.ad_id,
        qc1: returnQC.qc_1,
        qc2: returnQC.qc_2,
        qc1Username: returnQC.qc_1_username,
        qc2Username: returnQC.qc_2_username,
        qc2Fullname: returnQC.qc_2_fullname,
        qc1Fullname: returnQC.qc_1_fullname,
        on_hold: returnQC.on_hold,
        hold_qc_username: returnQC.hold_qc_username,
        hold_qc_fullname: returnQC.hold_qc_fullname,
        clear_qc_username: returnQC.clear_qc_username,
        clear_qc_fullname: returnQC.clear_qc_fullname
      };
    }

    if (qcServiceObj.adId) {
      const foundAd = this.findMatchingAd(qcServiceObj.adId);
      newStateAd = {
        ...foundAd,
        name,
        adQc: qcServiceObj,
        adNotes
      };
    }

    return newStateAd;
  };

  findMatchingAd = (adId) => {
    const flattenedSelectedAds = this.returnSelectedAds();
    const foundAd = flattenedSelectedAds.find((ad) => {
      return ad.id === adId;
    });
    return foundAd || {};
  };

  findMatchingAdCampaign = (adId) => {
    const { selectedAds } = this.props;
    const campaignKeys = Object.keys(selectedAds);
    let foundKey = '';
    campaignKeys.forEach((key) => {
      const index = selectedAds[key].findIndex((ad) => ad.id === adId);
      if (index !== -1) foundKey = key;
    });
    return foundKey;
  };

  processMultiQCResult = async (
    result,
    fullname,
    email,
    adId,
    qcNote,
    clearQc,
    noteType,
    selectedAllQc
  ) => {
    try {
      const { qcProcess: qcAdsProgress, actions } = this.props;
      const campaignKey = this.findMatchingAdCampaign(adId);
      const { totalAds: maxAdsFromCurrentCampaign } = qcAdsProgress[
        campaignKey
      ];

      if (selectedAllQc) {
        let totalQcOfCurrentCampaign = qcAdsProgress[campaignKey].totalQC;

        const belowMaxQc =
          totalQcOfCurrentCampaign <= maxAdsFromCurrentCampaign &&
          totalQcOfCurrentCampaign >= 0;

        if (belowMaxQc) {
          totalQcOfCurrentCampaign = !clearQc
            ? totalQcOfCurrentCampaign + 1
            : totalQcOfCurrentCampaign - 1;
        }

        if (totalQcOfCurrentCampaign > maxAdsFromCurrentCampaign) {
          totalQcOfCurrentCampaign -= 1;
        }
        if (totalQcOfCurrentCampaign < 0) {
          totalQcOfCurrentCampaign = 0;
        }

        qcAdsProgress[campaignKey].totalQC = totalQcOfCurrentCampaign;

        let totalAdsFromAllCampaigns = 0;
        let totalQcFromAllCampaigns = 0;

        Object.keys(qcAdsProgress).forEach((key) => {
          const { totalAds, totalQC } = qcAdsProgress[key];
          totalAdsFromAllCampaigns += totalAds;
          totalQcFromAllCampaigns += totalQC;
        });

        const generalQCProgress =
          (totalQcFromAllCampaigns * 100) / totalAdsFromAllCampaigns;
        actions.updateTotalQCAds(qcAdsProgress, generalQCProgress);
      }

      const { allNotes } = await this.insertNoteQC(
        adId,
        qcNote,
        email,
        fullname,
        noteType
      );
      return allNotes;
    } catch (error) {
      console.log('error in processMultiQCResult():', error);
      return [];
    }
  };

  insertNoteQC = async (adId, autoMessage, email, fullname, noteType) => {
    const qcNote = `${autoMessage} by ${fullname === '' ? email : fullname}`;
    const noteToInsert = {
      ad_id: adId,
      note_text: qcNote,
      username: email,
      fullname,
      note_qc: false,
      note_type: noteType
    };
    const insertNoteQcResult = await insertAdNote(noteToInsert);
    return insertNoteQcResult;
  };

  returnSelectedAds = () => {
    const { selectedAds } = this.props;
    const campaignKeys = Object.keys(selectedAds);
    const adGroupsFromCampaigns = [];
    campaignKeys.forEach((key) => {
      if (selectedAds[key].length > 0) {
        adGroupsFromCampaigns.push(selectedAds[key]);
      }
    });

    return adGroupsFromCampaigns.flat();
  };

  removeExistingAdInStateArray = (adId, adsWithQcArray) => {
    const foundAdIndex = adsWithQcArray.findIndex((ad) => ad.id === adId);
    if (foundAdIndex !== -1) {
      adsWithQcArray.splice(foundAdIndex, 1);
    }
    return adsWithQcArray;
  };

  approveMultiQc = async (approveAll, qcNote) => {
    this.setState({ loading: true, isMultiQcPopupOpen: false });
    const { user, updateParentState } = this.props;
    const { email } = user;
    const fullname = getFullNameOrUserName(user);
    const { newStateAds } = this.state;
    let newStateArray = [...newStateAds];
    const adData = this.returnSelectedAds();
    let toastMessage = 'QCs approved for the selected ads.';

    await Promise.all(
      adData.map(async (adObject) => {
        const { adQc, id, name } = adObject;
        const qc1 = adQc ? adQc.qc1 : 'false';
        const qc2 = adQc ? adQc.qc2 : 'false';
        if (qc1 === 'true' && qc2 === 'true') {
          toast(`${name} has already been QC-ed`, {
            position: toast.POSITION.TOP_RIGHT,
            autoClose: 4000,
            type: toast.TYPE.WARNING,
            hideProgressBar: true,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true
          });
        } else {
          const willAddQc =
            (approveAll && qc2 === 'false') || (!approveAll && qc1 === 'true');
          const qcInfo = {
            ad_id: id,
            fullname,
            username: email,
            approveAll
          };
          const result = await approveQC(qcInfo);
          const defaultQcMessage = approveAll
            ? 'All Multi QC Approved'
            : 'Multi single QC Approved';

          const qcNoteToInsert =
            qcNote && qcNote.trim() !== '' ? qcNote : defaultQcMessage;
          const adNotesFromProcessing = await this.processMultiQCResult(
            result,
            fullname,
            email,
            qcInfo.ad_id,
            qcNoteToInsert,
            false,
            1,
            willAddQc
          );
          const processResult = this.mapQCServiceObject(
            result,
            adNotesFromProcessing
          );
          if (processResult) {
            const { id: processAdId } = processResult;
            const removedDupplicateFromStateArray = this.removeExistingAdInStateArray(
              processAdId,
              newStateArray
            );
            newStateArray = removedDupplicateFromStateArray;
            newStateArray.push(processResult);
          }
        }
      })
    );
    if (approveAll) toastMessage = 'All QCs approved for the selected ads.';
    toast(`${toastMessage}`, {
      position: toast.POSITION.BOTTOM_CENTER,
      autoClose: 3000,
      type: toast.TYPE.SUCCESS,
      hideProgressBar: true,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true
    });

    this.setState(
      {
        qcNote: '',
        newStateAds: newStateArray,
        toggleMultiQcPopup: false
      },
      () => {
        const { newStateAds: updatedNewStateAds } = this.state;
        this.setState({ loading: false }, () => {
          if (updateParentState) {
            updateParentState(updatedNewStateAds, true);
          }
        });
      }
    );
  };

  clearMultiQc = async (qcNote) => {
    this.setState({ loading: true, isMultiQcPopupOpen: false });
    const { user, updateParentState } = this.props;
    const { email } = user;
    const fullname = getFullNameOrUserName(user);
    const { newStateAds } = this.state;
    let newStateArray = [...newStateAds];
    const adData = this.returnSelectedAds();

    await Promise.all(
      adData.map(async (adObject) => {
        const { adQc, id, name } = adObject;
        const qc1 = adQc ? adQc.qc1 : 'false';
        const qc2 = adQc ? adQc.qc2 : 'false';
        const onHold = adQc ? adQc.on_hold : null;
        if (qc1 === 'false' && qc2 === 'false' && !onHold) {
          toast(`${name} has no QCs to clear`, {
            position: toast.POSITION.TOP_RIGHT,
            autoClose: 5000,
            type: toast.TYPE.WARNING,
            hideProgressBar: true,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true
          });
        } else {
          const willClearQc = qc2 === 'true';
          const qcInfo = {
            ad_id: id,
            fullname,
            username: email
          };
          const result = await clearAdQC(qcInfo);
          const qcNoteToInsert =
            qcNote.trim() !== '' ? qcNote : 'Multi QC Clear All';
          const adNotesFromProcessing = await this.processMultiQCResult(
            result,
            fullname,
            email,
            qcInfo.ad_id,
            qcNoteToInsert,
            true,
            2,
            willClearQc
          );
          const processResult = this.mapQCServiceObject(
            result,
            adNotesFromProcessing
          );
          if (processResult) {
            const { id: processAdId } = processResult;
            const removedDupplicateFromStateArray = this.removeExistingAdInStateArray(
              processAdId,
              newStateArray
            );
            newStateArray = removedDupplicateFromStateArray;
            newStateArray.push(processResult);
          }
        }
      })
    );

    toast(`Ad QCs for the selected ads cleared.`, {
      position: 'bottom-center',
      autoClose: 3000,
      type: toast.TYPE.ERROR,
      hideProgressBar: true,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true
    });

    this.setState(
      {
        qcNote: '',
        newStateAds: newStateArray,
        toggleMultiQcPopup: false
      },
      () => {
        const { newStateAds: updatedNewStateAds } = this.state;
        this.setState({ loading: false }, () => {
          if (updateParentState) {
            updateParentState(updatedNewStateAds, true);
          }
        });
      }
    );
  };

  holdAds = async (qcNote) => {
    this.setState({ loading: true, isMultiQcPopupOpen: false });
    const { user, updateParentState, getFbToken } = this.props;
    const token = getFbToken();
    const { email, sub } = user;
    const fullname = getFullNameOrUserName(user);
    const { newStateAds } = this.state;
    let newStateArray = [...newStateAds];
    const adData = this.returnSelectedAds();

    if (adData.length < 1) {
      toast(`No ads have been selected.`, {
        position: toast.POSITION.BOTTOM_CENTER,
        autoClose: 4000,
        type: toast.TYPE.WARNING,
        hideProgressBar: true
      });
    } else {
      const holdAndReleaseResults = await Promise.all(
        adData.map(async (adObject) => {
          const { id, name } = adObject;
          const qcInfo = {
            ad_id: id,
            fullname,
            username: email,
            userid: sub
          };

          const result = await updateAdHold(qcInfo);
          const { returnQC } = result;
          const { on_hold: returnOnHold } = returnQC || {};
          const defaultNote = returnOnHold
            ? 'Multi-ad hold'
            : 'Multi-ad release';
          const qcNoteToInsert = qcNote.trim() !== '' ? qcNote : defaultNote;

          const data = {
            id,
            name: returnOnHold ? name.concat(' -HELD') : name.split(' -HELD')[0]
          };

          result.name = data.name;

          const adNotesFromProcessing = await this.processMultiQCResult(
            result,
            fullname,
            email,
            qcInfo.ad_id,
            qcNoteToInsert,
            true,
            returnOnHold ? 3 : 5,
            false
          );

          const updateStatusResult = await updateStatusAd(id, token, 'PAUSED');

          const updateResult = await updateAd(data, token);

          const processResult = this.mapQCServiceObject(
            result,
            adNotesFromProcessing
          );

          if (
            (!updateResult.ok && updateResult.status !== 200) ||
            (!updateStatusResult.ok && updateStatusResult.status !== 200)
          ) {
            toast(`Something went wrong while processing ${name}`, {
              position: toast.POSITION.TOP_RIGHT,
              autoClose: 4000,
              type: toast.TYPE.ERROR,
              hideProgressBar: true
            });
            processResult.name = name;
          }

          if (processResult) {
            const { id: processAdId } = processResult;
            const removedDuplicateFromStateArray = this.removeExistingAdInStateArray(
              processAdId,
              newStateArray
            );
            newStateArray = removedDuplicateFromStateArray;
            newStateArray.push(processResult);
            return processResult;
          }

          return result;
        })
      );

      const numberOfHeld = holdAndReleaseResults.filter(
        (result) => result.adQc.on_hold
      ).length;
      const numberOfReleased = holdAndReleaseResults.length - numberOfHeld;

      const successMessage = `Operation complete. Held Ads:${numberOfHeld}, Released Ads: ${numberOfReleased}`;
      toast(successMessage, {
        position: toast.POSITION.BOTTOM_CENTER,
        autoClose: 5000,
        type: toast.TYPE.SUCCESS,
        hideProgressBar: true
      });
    }

    this.setState(
      {
        qcNote: '',
        newStateAds: newStateArray,
        toggleMultiQcPopup: false
      },
      () => {
        const { newStateAds: updatedNewStateAds } = this.state;
        this.setState({ loading: false }, () => {
          if (updateParentState) {
            updateParentState(updatedNewStateAds, true);
          }
        });
      }
    );
  };

  renderQcPopupContent = () => {
    const { qcNote } = this.state;
    return (
      <div>
        <Grid verticalAlign="middle" stackable>
          <Grid.Row>
            <Grid.Column>
              <Input
                fluid
                placeholder="Add Note to the QC"
                value={qcNote}
                onChange={(event, data) => {
                  this.setState({ qcNote: data.value });
                }}
              />
            </Grid.Column>
          </Grid.Row>
          <Grid.Row>
            <Grid.Column verticalAlign="middle">
              <Button
                basic
                compact
                color="olive"
                onClick={() => this.approveMultiQc(false, qcNote)}
              >
                Approve
              </Button>
              <Button
                basic
                compact
                color="green"
                onClick={() => this.approveMultiQc(true, qcNote)}
              >
                Approve All
              </Button>
            </Grid.Column>
          </Grid.Row>
          <Grid.Row>
            <Grid.Column verticalAlign="middle">
              <Button
                basic
                compact
                color="blue"
                onClick={() => this.holdAds(qcNote)}
              >
                Hold/Release Ads
              </Button>
              <Button
                basic
                compact
                color="red"
                onClick={() => this.clearMultiQc(qcNote)}
              >
                Clear All
              </Button>
            </Grid.Column>
          </Grid.Row>
        </Grid>
      </div>
    );
  };

  renderMultiQcButtons = () => {
    const { isMultiQcPopupOpen, loading } = this.state;
    const { processing, showCheckboxesMultiQc, showCheckboxes } = this.props;
    return (
      <div style={{ float: 'right' }}>
        <Dimmer.Dimmable dimmed={loading}>
          <Dimmer active={loading} inverted>
            <Loader size="tiny">Processing</Loader>
          </Dimmer>
          {!showCheckboxesMultiQc ? (
            <Button
              disabled={processing || showCheckboxes}
              basic
              color="purple"
              onClick={this.toggleMultiQcMode}
            >
              Multi QC
            </Button>
          ) : (
            <div>
              <Popup
                wide
                basic
                open={isMultiQcPopupOpen && showCheckboxesMultiQc}
                position="left center"
                trigger={
                  <Button basic color="blue" onClick={this.toggleMultiQcPopup}>
                    Actions
                  </Button>
                }
                content={this.renderQcPopupContent()}
                on="click"
              />
              <Button basic color="red" onClick={this.toggleMultiQcMode}>
                Close
              </Button>
            </div>
          )}
        </Dimmer.Dimmable>
      </div>
    );
  };

  render() {
    return this.renderMultiQcButtons();
  }
}

const mapStateToProps = (state) => {
  const { user, adPreview, adQc } = state;
  const { selectedAds, showCheckboxes, showCheckboxesMultiQc } = adPreview;

  return {
    user,
    selectedAds,
    qcProcess: adQc.qcProcess,
    showCheckboxes,
    showCheckboxesMultiQc
  };
};

const mapDispatchToProps = (dispatch) => ({
  actions: bindActionCreators(AppActions, dispatch)
});

export default connect(mapStateToProps, mapDispatchToProps)(AdPreviewMultiQc);



// WEBPACK FOOTER //
// ./src/screens/Presentation/PresentationComponents/AdPreviewMultiQc.js